import script from "./WorkspaceFullscreen.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceFullscreen.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceFullscreen.vue?vue&type=style&index=0&id=9f5dbaca&lang=css"

const __exports__ = script;

export default __exports__